import { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';

const useScrollPosition = (): [number, boolean] => {
  const [scrollPosition, setScrollPosition] = useState<number>(0);
  const [isScrollStopped, setIsScrollStopped] = useState<boolean>(false);

  useEffect(() => {
    let timeoutId: number;

    const handleScroll = () => {
      setScrollPosition(window.scrollY);
      setIsScrollStopped(false); // Сброс флага при каждом скролле

      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsScrollStopped(true);
      }, 200);
    };

    const throttledScroll = throttle(handleScroll, 200);

    window.addEventListener('scroll', throttledScroll);

    return () => {
      window.removeEventListener('scroll', throttledScroll);
    };
  }, []);

  return [scrollPosition, isScrollStopped];
};

export { useScrollPosition };
